<template>
  <div class="photo-upload" :class="disabled ? 'disabled' : 'enabled'">
    <div class="uploader" :class="{hovering: hovering}" :style="{backgroundImage: backgroundImage}" ref="uploader">
      <a href @click.prevent="clear()" class="photo-upload-clear">
        <i class="fa fa-times"></i>
      </a>
      <span v-show="!(value || preview)" class="upload-instructions">
        <slot>
          Click or drag
          <br>
          image here
          <br>
          to upload...
        </slot>
      </span>
      <input class="file-photo" type="file" @change="handleImage" @dragenter="hovering = true"
             @dragleave="hovering = false" :disabled="disabled" ref="file" />
    </div>
  </div>
</template>

<style>
  .uploader {
    position: relative;
    overflow: hidden;
    width: 300px;
    height: 250px;
    background-color: #f3f3f3;
    background-size: contain;
    background-position: center center;
    background-repeat: no-repeat;
    border: 2px dashed #e8e8e8;
    display: inline-block;
  }

  .enabled .uploader.hovering {
    background-color: #bbb;
  }

  .photo-upload-clear {
    position: absolute;
    z-index: 4;
    top: 10px;
    right: 10px;
  }

  .enabled .uploader:hover {
    background-color: skyblue;
  }

  .upload-instructions {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    text-align: center;
  }

  .file-photo {
    position: absolute;
    width: 300px;
    height: 400px;
    top: -50px;
    left: 0;
    z-index: 2;
    opacity: 0;
  }
  .enabled .file-photo {
    cursor: pointer;
  }

</style>

<script>
export default {
    props: ['value', 'disabled'],
    methods: {
        handleImage(event) {
            if (this.disabled) {
                return;
            }
            let files = event.target.files;
            if (files.length === 0){
                return;
            }
            let reader = new FileReader();
            reader.onload = (event) => {
                this.preview = event.target.result;
                this.$emit('input', files[0]);
            };
            reader.readAsDataURL(files[0]);

        },
        clear() {
            this.$emit('clear', null);
            this.preview = null;
            this.$refs.file.value = null;
        }
    },
    data() {
        return {
            hovering: false,
            preview: null
        };
    },
    watch: {
        value() {
            this.preview = null;
            this.$refs.file.value = null;
        },
    },
    computed: {
        backgroundImage() {
            let image = this.preview || this.value;
            if (!image) {
                return null;
            }
            return `url('${image}')`;
        }
    }
};
</script>



// WEBPACK FOOTER //
// resources/js/ui/PhotoUpload.vue